import React from 'react';
import { SInfoLarge } from '../styles/Footer.styled';

const ForgotPasswordConfirmationForm: React.FC = () => {
  return (
    <>
      <SInfoLarge id="idAccountAssociated">If there is an account associated with this</SInfoLarge>
      <SInfoLarge id="idInstructionsSent">username/email, instructions will be sent to the</SInfoLarge>
      <SInfoLarge id="idEmailOnRecord">email address on record.</SInfoLarge>
    </>
  );
};

export default ForgotPasswordConfirmationForm;
